export default {
    get_research: state => { return state.launch_research},
    get_reset_rate_list: state => { return state.reset_rate_list},
    get_pnocl: state => { return state.pnocl},
    get_pnlot: state => { return state.pnlot},
    get_fmod: state => { return state.fmod},
    get_ftail: state => { return state.ftail}
};